import type { ComponentProps } from 'react'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import StarRating from 'components/Common/StarRating'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import FormatDecimal from 'components/utils/Formatters/FormatDecimal'

type Size = 'S' | 'M'
const BODY_TEXT_SIZES: Record<
  Size,
  ComponentProps<typeof BodyText>['variant']
> = {
  S: 'small',
  M: 'medium',
}

const STAR_RATING_SIZES: Record<
  Size,
  ComponentProps<typeof StarRating>['size']
> = {
  S: 16,
  M: 'XS',
}

type Props = {
  rating: number
  ratingsCount?: number
  size: Size
  className?: string
  label?: string
}
function GooglePlaceRatingDisplay(props: Props) {
  const {
    rating,
    ratingsCount,
    label,
    className,
    size,
  } = props

  return (
    <Group gap={8} direction="vertical" className={className}>
      {label && (
        <BodyText variant="medium" weight="bold">
          {label}
        </BodyText>
      )}
      <Group
        gap={4}
        direction="horizontal"
        horizontalAlign="start"
        verticalAlign="center"
      >
        <Group direction="horizontal" verticalAlign="center" gap={2}>
          <StarRating max={1} value={rating} size={STAR_RATING_SIZES[size]} />
          <BodyText variant={BODY_TEXT_SIZES[size]}>{rating}</BodyText>
        </Group>

        {ratingsCount && (
          <BodyText variant={BODY_TEXT_SIZES[size]} colour="neutral-two">
            <FormattedMessage
              id="N7OFggUqJL"
              defaultMessage="({count})"
              description="Google place ratings count in parentheses in the trip planner"
              values={{
                count: <FormatDecimal
                  value={ratingsCount}
                  notation="compact"
                  compactDisplay="short"
                />,
              }}
            />
          </BodyText>
        )}
      </Group>
    </Group>
  )
}

export default GooglePlaceRatingDisplay
